export default "/048cb1f2b29308e18768c65cfd51e426596a830c/bafcb97f65150dd63b7cabadb0e0f790.svg";